import { Button } from '@chakra-ui/react';

export default function LoginButton(props) {
    return (
        <Button { ...props }>
            Login with Google
        </Button>
    );
}
